export enum DayOffTypeEnum {
  Vacation = 'vacation',
  Holiday = 'holiday',
  Absence = 'absence',
  ExcusedRemote = 'excused_remote',
}

export function getDayOffTypeEmoji(day_off_type: DayOffTypeEnum): string {
  switch (day_off_type) {
    case DayOffTypeEnum.Vacation:
      return '🌴';
    case DayOffTypeEnum.Holiday:
      return '🎆';
    case DayOffTypeEnum.Absence:
      return '🪑';
    case DayOffTypeEnum.ExcusedRemote:
      return '🏠';
  }
}

export function getDayOffTypeLabel(day_off_type: DayOffTypeEnum): string {
  switch (day_off_type) {
    case DayOffTypeEnum.Vacation:
      return 'Vacaciones';
    case DayOffTypeEnum.Holiday:
      return 'Festivo';
    case DayOffTypeEnum.Absence:
      return 'Ausencia';
    case DayOffTypeEnum.ExcusedRemote:
      return 'Teletrabajo excusado';
  }
}
